<template>
  <pt-detection-new class="pt-detection-new__withData"></pt-detection-new>
</template>

<script>
import PtDetectionNew from './index'
export default {
  name: 'pt-detection-new__withData',
  components: {
    'pt-detection-new': PtDetectionNew
  }
}
</script>
